import { lazy, Suspense } from 'react';
import { Box, Skeleton } from '@mui/material';

const RichTextEditorImpl = lazy(() => import('./RichTextEditor.impl'));

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  minHeight?: number;
  helperText?: string;
  label?: string;
  error?: boolean;
}

const EditorFallback = ({ minHeight = 160 }: { minHeight?: number }) => (
  <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '8px', overflow: 'hidden' }}>
    <Skeleton variant="rectangular" height={40} sx={{ bgcolor: 'background.default' }} />
    <Skeleton variant="rectangular" height={minHeight} />
  </Box>
);

export default function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense fallback={<EditorFallback minHeight={props.minHeight} />}>
      <RichTextEditorImpl {...props} />
    </Suspense>
  );
}
